import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import { restReducer } from '../h2Api'
import { LOAD_MY_STUFF } from '../actions/myStuff'

export default combineReducers({
  data: restReducer(LOAD_MY_STUFF),
  forms: combineForms(
    {
      filter: {
        dateRange: '2',
        filter: {
          budgets: true,
          courses: dynamicValues.coursePlanEnabled,
          files: dynamicValues.isSubscriber,
          ip: true,
          journals: true,
          liked: true,
          mgmtreport: dynamicValues.isSubscriber,
          sp: true,
          utl:
            dynamicValues.upTheLadder || dynamicValues.userProfile?.hasUpTheLadderAccess,
          wip: true,
          plans: true,
          workkeys: dynamicValues.workKeys
        }
      }
    },
    'myStuff.forms'
  )
})
